const TOKEN_KEY = 'Utopia-Token';
const MODE_KEY = 'Theme-Mode';
export function getToken() {
  return isSignedIn() ? window.sessionStorage.getItem(TOKEN_KEY) : null;
}

export function setToken(token) {
  window.sessionStorage.setItem(TOKEN_KEY, token);
}

export function signOut() {
  window.sessionStorage.removeItem(TOKEN_KEY);
}

export function isSignedIn() {
  return !!window.sessionStorage.getItem(TOKEN_KEY);
}
